export function summarizeLiveAccountLayout(layout = []) {
    const items = Array.isArray(layout) ? layout : [];
    if (!items.length) {
        return "Live status checks unavailable";
    }

    const groups = {
        ready: [],
        missingMapping: [],
        missingKeys: [],
        missingSizing: [],
        disabled: [],
        policyExcluded: [],
        walletNotReady: [],
        clientMissing: [],
        blocked: [],
        unknown: [],
    };

    items.forEach((item) => {
        const name = (item?.symbol || item?.coin_key || item?.slug || "Unknown").toString().toUpperCase();
        const hasMapping = Boolean(item?.binance_account_prefix);
        const envKeys = item?.env_keys_present || {};
        const envOk = Boolean(envKeys.key) && Boolean(envKeys.secret);
        const sizingOk = item?.sizing_rules_loaded ?? true;
        const binanceEnabled = item?.binance_enabled === true;
        const canTrade = item?.can_trade_live;
        const blocking = Array.isArray(item?.blocking_reasons) ? item.blocking_reasons.map(String) : [];

        if (binanceEnabled && hasMapping && envOk && sizingOk && canTrade === true && blocking.length === 0) {
            groups.ready.push(name);
            return;
        }

        if (!hasMapping) groups.missingMapping.push(name);
        if (!envOk) groups.missingKeys.push(name);
        if (!sizingOk) groups.missingSizing.push(name);
        if (!binanceEnabled || blocking.includes("binance_enabled_false") || blocking.includes("binance_disabled")) groups.disabled.push(name);
        if (item?.policy_excluded === true || blocking.includes("policy_excluded")) groups.policyExcluded.push(name);
        if (item?.wallet_ready === false || item?.live_wallet_ready === false || blocking.some((r) => r.includes("wallet"))) groups.walletNotReady.push(name);
        if (
            item?.client_ready === false ||
            item?.binance_client_ready === false ||
            item?.client_present === false ||
            item?.binance_client_present === false ||
            blocking.some((r) => r.includes("client"))
        ) {
            groups.clientMissing.push(name);
        }
        if (typeof canTrade !== "boolean") groups.unknown.push(name);
        if (canTrade === false && blocking.length && binanceEnabled) groups.blocked.push(name);
    });

    const parts = [];
    if (groups.ready.length) parts.push(`Checks passing: ${groups.ready.join(", ")}`);
    if (groups.disabled.length) parts.push(`Disabled: ${groups.disabled.join(", ")}`);
    if (groups.policyExcluded.length) parts.push(`Policy-excluded: ${groups.policyExcluded.join(", ")}`);
    if (groups.missingMapping.length) parts.push(`Missing mapping: ${groups.missingMapping.join(", ")}`);
    if (groups.missingKeys.length) parts.push(`Missing keys: ${groups.missingKeys.join(", ")}`);
    if (groups.clientMissing.length) parts.push(`Missing client: ${groups.clientMissing.join(", ")}`);
    if (groups.walletNotReady.length) parts.push(`Wallet not ready: ${groups.walletNotReady.join(", ")}`);
    if (groups.missingSizing.length) parts.push(`Sizing rules: ${groups.missingSizing.join(", ")}`);
    if (!parts.length && groups.blocked.length) {
        parts.push(`Blocked: ${groups.blocked.join(", ")}`);
    }
    if (groups.unknown.length) parts.push(`Unknown checks: ${groups.unknown.join(", ")}`);

    return parts.join(" • ") || "No live check-passing coins";
}

export default summarizeLiveAccountLayout;
